import type { Scope } from '../types/governance'

/**
 * Audit entries record the scope they happened in as a human LABEL
 * ("FUTA · Main Campus · housing"), not as a structured scope — the label is
 * what an investigator needs to read years later, when the tenant tree may have
 * been reorganised.
 *
 * That means a structured `scopeCovers()` comparison cannot be used against
 * them. Matching is therefore by label: a global scope covers every entry, and
 * a narrower scope covers entries whose recorded label begins with it, since
 * the labels are written outermost-first.
 *
 * Deliberately conservative in the other direction: an entry we cannot place is
 * excluded rather than shown, and the surfaces using this say how many entries
 * they are showing out of how many, so an exclusion is never silent.
 */
export function auditInScope(recordScope: string, active: Scope, activeLabel: string): boolean {
  if (active.level === 'global') return true
  const held = activeLabel.trim().toLowerCase()
  if (!held) return true
  return recordScope.trim().toLowerCase().startsWith(held)
}
